import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { NgxPermissionsService } from "ngx-permissions";
import { NgxSpinnerService } from "ngx-spinner";
import SignaturePad from "signature_pad";
import { AppService } from "src/app/services/app/app.service";
import { CommonService } from "src/app/services/common/common.service";
import { CompanyService } from "src/app/services/company/company.service";
import { GlobalService } from "src/app/services/global/global.service";
interface cerData {
  cer_lo: string;
  c_msg: string;
  d_c: string;
  sign: string;
}
@Component({
  selector: "app-certificate-management",
  templateUrl: "./certificate-management.component.html",
  styleUrls: ["./certificate-management.component.scss"],
})
export class CertificateManagementComponent {
  public signPad: any;
  @ViewChild("signPadCanvas", { static: false }) signaturePadElement: any;
  @ViewChild("signbox", { static: false }) signBox: any
  public files: File[] = [];
  public certificateArr: any[] = [];
  public filteredCertArr: any[] = [];
  public isLandscapeView: boolean = true;
  public imageUrl: string = GlobalService.imageURL;
  public certificateData: cerData = {} as cerData;
  public imagePath;
  public isImageError: boolean = false;
  public isAdmin: boolean = false;
  constructor(private spinner: NgxSpinnerService, private companyService: CompanyService, private appService: AppService, private cookieService: CookieService,
    private commonService: CommonService, private permissionService: NgxPermissionsService, private router: Router) { }

  ngOnInit(): void {
    if (this.cookieService.get('user_id') && window.location.href.includes('admin-cert')) {
      // whenever admin user set the token of admin 
      this.appService.storeData('training-portal.admin-authToken', this.cookieService.get('user_id'));
      this.appService.storeSessionData('isAdmin', JSON.stringify(true));
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
    }
    this.commonService.setTitle("Certificate Management")
    this.permissionService.loadPermissions(this.appService.getPermissionforUser())
    this.getCertificateData()
  }
  ngAfterViewInit() {
    this.signPad = new SignaturePad(this.signaturePadElement.nativeElement);
    this.resizeCanvas()
  }
  resizeCanvas() {
    const canvas = this.signaturePadElement.nativeElement;
    const context = canvas.getContext('2d');

    // Set canvas width and height dynamically
    const dynamicWidth = this.signBox.nativeElement.offsetWidth - 16
    const dynamicHeight = this.signBox.nativeElement.offsetHeight - 16
    canvas.width = dynamicWidth;
    canvas.height = dynamicHeight;
  }
  onSelect(event) {
    this.files = []
    this.files.push(...event.addedFiles);
    var reader = new FileReader();
    reader.readAsDataURL(event.addedFiles[0]);
    reader.onload = (_event) => {
      this.imagePath = reader.result
      if (this.certificateData.cer_lo) {
        this.certificateData.cer_lo = ''
      }
      this.commonService.validateImage(event.addedFiles[0], 'certificate').then((isValidImage) => {
        if (isValidImage) {
          this.isImageError = false
        } else {
          this.isImageError = true
        }
      }).catch((error) => {
      })
      if (!this.commonService.validateImage(event.addedFiles[0], 'certificate')) {
        this.isImageError = true
      }
      else {
        this.isImageError = false
      }
    }
  }
  onViewChange() {
    // this.defaultCerArr.filter()
    this.isLandscapeView = !this.isLandscapeView;
    this.filterCertData()
  }
  onCertificateSelect(item: any) {
    this.certificateArr.map((i) => (i.selected = item.id == i.id ? true : false));
  }
  clearSignPad() {
    this.signPad.clear();
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  getCertificateData() {
    this.imagePath = ""
    this.companyService.getCertificateData().subscribe({
      next: (success) => {
        this.certificateData = success["data"];
        this.certificateArr = success["data"]["default_cer_data"];
        // this.defaultCerArr =
        if (this.certificateData.d_c) {
          this.certificateArr.map(
            (i) =>
            (i.selected =
              this.certificateData.d_c == i.id ? true : false)
          );
          let selectedCert = this.certificateArr.find(
            (item) => item.id == this.certificateData.d_c
          );
          if (selectedCert.cer_t == 1) {
            this.isLandscapeView = false;
          } else {
            this.isLandscapeView = true;
          }
        } else {
          this.certificateArr[0].selected = true;
        }
        this.filterCertData();
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  filterCertData() {
    this.filteredCertArr = [...this.certificateArr]
    if (this.isLandscapeView == true) {
      this.filteredCertArr = this.filteredCertArr.filter(item => item.cer_t == 0)
    }
    else {
      this.filteredCertArr = this.filteredCertArr.filter(item => item.cer_t == 1)
    }
  }
  submitCertificateData() {
    let formData = new FormData()
    let selectedCertificateId = this.certificateArr.find(obj => obj.selected === true)
    if (this.imagePath) {
      formData.append('cer_lo', this.files[0])
    }
    formData.append('d_c', selectedCertificateId.id)
    if (!this.signPad.isEmpty()) {
      formData.append('sign', this.signPad.toDataURL())
    }
    formData.append('cer_lo', this.signPad.toDataURL())
    formData.append('c_msg', this.certificateData.c_msg)
    if (!this.isImageError) {
      this.spinner.show()
      this.companyService.updateCertificate(formData).subscribe({
        next: (success) => {
          this.spinner.hide();
          if (success["status"] == 200) {
            this.appService.showToastMessage("success", success["msg"]);
            this.getCertificateData();
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
    
  }
}
